import React from "react";

import theme from "@/styles/themes/theme";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Document } from "@contentful/rich-text-types";
import { Accordion, AccordionDetails, AccordionSummary, Card, Stack, Typography } from "@mui/material";
import { CaretDown } from "@phosphor-icons/react";

import { styles } from "./styles";

interface SwapInstructionsProps {
  itemSwapInstructions?: Document;
}

export const SwapInstructions: React.FC<SwapInstructionsProps> = ({ itemSwapInstructions }) => {
  if (!itemSwapInstructions) {
    return null;
  }

  return (
    <Stack mb={10} sx={{ pt: 4 }}>
      <Accordion>
        <AccordionSummary expandIcon={<CaretDown />}>
          <Typography fontSize={16} fontWeight={600}>
            Como Trocar
          </Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ bgcolor: theme.palette.primary.main }}>
          <Card sx={{ bgcolor: theme.palette.common.white, p: 2 }}>
            <Typography component="div" pl={2} css={styles.typography__description}>
              {documentToReactComponents(itemSwapInstructions)}
            </Typography>
          </Card>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};
